export default __webpack_public_path__ + "static/media/NEW-INVESTA.0355495a.png";